export default __webpack_public_path__ + "static/media/bs.527d0fc0.svg";